import {
  AfterViewInit,
  Component,
  effect,
  ElementRef,
  input,
  InputSignalWithTransform,
  OnDestroy,
  ViewChild,
} from '@angular/core';
import {CommonModule} from '@angular/common';
import {Scroller} from '@selpia/shared/utils';

import {map, Observable} from 'rxjs';

@Component({
  selector: 'lib-scroller',
  imports: [CommonModule],
  templateUrl: './scroller.component.html',
  styleUrl: './scroller.component.scss',
})
export class ScrollerComponent<T> implements AfterViewInit, OnDestroy {
  scroller: Scroller | null = null;

  fadeOutClass$!: Observable<string>;

  forceChange: InputSignalWithTransform<number, T | undefined> = input(0,
    {
      transform: () => new Date().getTime(),
    }
  );

  constructor() {
    effect(() => {
      if (this.forceChange() && this.scroller) {
        this.scroller.check()
      }
    });
  }

  @ViewChild('contentScroller')
  private contentScrollerElementRef!: ElementRef;

  @ViewChild('content')
  private contentElementRef!: ElementRef;

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.initialize();
    });
  }

  ngOnDestroy(): void {
    this.scroller?.destroy();
  }

  private initialize() {
    this.scroller = new Scroller(
      this.contentScrollerElementRef.nativeElement,
      this.contentElementRef.nativeElement,
    );

    this.fadeOutClass$ = this.scroller.canScroll$.pipe(
      map(({left, right}) => left === right
        ? left
          ? 'fadeout fadeout-both'
          : 'fadeout fadeout-none'
        : left
          ? 'fadeout fadeout-left'
          : 'fadeout fadeout-right'
      )
    );
  }
}
